import { render } from "./TheTop.vue?vue&type=template&id=4d514e75"
import script from "./TheTop.vue?vue&type=script&lang=js"
export * from "./TheTop.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__